import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1051"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M3.356 10.625h1.38c.159 0 .299.086.418.322.374.737 1.524 2.786 4.07 2.374 2.615-.423 1.87-2.964.6-3.839C8.69 8.7 5.695 8.665 4.25 7.288c-1.444-1.376-1.589-4.183.578-5.613 2.123-1.401 4.907-.92 6.165.106.979.799 1.338 1.825 1.469 2.437.058.272-.19.533-.462.533h-1.416c-.183 0-.374-.115-.465-.378-.149-.425-.345-1.195-1.302-1.533-1.3-.477-3.346.01-3.65 1.346-.291 1.419 1.569 1.99 2.793 2.33 1.321.367 3.696 1.01 4.53 2.504.915 1.642.778 3.507-.678 4.888-1.46 1.384-4.26 1.65-5.925.807-1.733-.877-2.641-2.61-2.932-3.53a.426.426 0 0 1 .401-.56z",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }